module.exports = __webpack_public_path__ + "img/horizontal_4_2_r_pp2_8011.a02c49fa.png";